import type { PayloadAction } from '@reduxjs/toolkit';
import isEmpty from 'lodash/isEmpty';
import type { InitialFilterStateType } from 'src/redux/filter/types';

const handleFilters = (
  data: { [key: string]: string } | Array<string>,
  type: 'update' | 'reset' | 'submit' | 'clear_all',
  state: InitialFilterStateType,
  key: keyof InitialFilterStateType,
) => {
  if (type === 'update') {
    state[key].appliedFilters = {
      ...state[key].appliedFilters,
      ...data,
    } as { [key: string]: string };
  }
  if (type === 'submit') {
    const newFilter = data as { [key: string]: string };
    const newValues = { ...state[key].appliedFilters };
    Object.keys(newFilter)?.forEach((item: string) => {
      if (!isEmpty(newFilter[item])) {
        newValues[item] = newFilter[item];
      } else {
        delete newValues[item];
      }
    });
    state[key].appliedFilters = newValues;
  }
  if (type === 'reset') {
    const resetKeys = data as Array<string>;
    const { appliedFilters } = state[key];
    if (resetKeys?.length) {
      resetKeys?.forEach((filterKey) => {
        delete appliedFilters[filterKey as string];
      });
    }
    state[key].appliedFilters = appliedFilters;
  }
  if (type === 'clear_all') {
    state[key].appliedFilters = {};
  }
};

const reducers = {
  updateUserFilter: (
    state: InitialFilterStateType,
    action: PayloadAction<{
      data: InitialFilterStateType['usersListFilter']['appliedFilters'] | Array<string>;
      type: 'update' | 'reset' | 'submit' | 'clear_all';
    }>,
  ) => {
    const { data, type } = action.payload;
    handleFilters(data, type, state, 'usersListFilter');
  },
  updateRoleFilter: (
    state: InitialFilterStateType,
    action: PayloadAction<{
      data: InitialFilterStateType['roleListFilter']['appliedFilters'] | Array<string>;
      type: 'update' | 'reset' | 'submit' | 'clear_all';
    }>,
  ) => {
    const { data, type } = action.payload;
    handleFilters(data, type, state, 'roleListFilter');
  },
  updateVendorFilter: (
    state: InitialFilterStateType,
    action: PayloadAction<{
      data: InitialFilterStateType['vendorListFilter']['appliedFilters'] | Array<string>;
      type: 'update' | 'reset' | 'submit' | 'clear_all';
    }>,
  ) => {
    const { data, type } = action.payload;
    handleFilters(data, type, state, 'vendorListFilter');
  },
};

export default reducers;
